import { render, staticRenderFns } from "./billing-reports.vue?vue&type=template&id=2fdff2c4&"
import script from "./billing-reports.vue?vue&type=script&lang=js&"
export * from "./billing-reports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports